//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';

import { MediaFilterParamKey } from '@apis/content-library/contentLibraryApiModel';
import HR from '@components/atoms/hr/HR';
import { CheckboxSetFilter } from '@components/media-filters/CheckboxSetFilter';
import { CollapsibleSection } from '@components/media-filters/CollapsibleSection';
import {
  FilterSection,
  FilterSectionTitle,
  FilterValue,
} from '@components/media-filters/filterSectionModels';
import { MediaLibraryTrackingIds } from '@media-library/constants/mediaLibraryTrackingIds';

export const DEFAULT_MEDIA_TYPE_FILTER_SECTION: FilterSection<string> = {
  options: [
    {
      isSelected: false,
      value: 'Image',
      label: 'Image',
      trackingId: MediaLibraryTrackingIds.MEDIA_TYPE_IMAGE_CHECKBOX,
    },
    {
      isSelected: false,
      value: 'Video',
      label: 'Video',
      trackingId: MediaLibraryTrackingIds.MEDIA_TYPE_VIDEO_CHECKBOX,
    },
    {
      isSelected: false,
      value: 'Gif',
      label: 'GIF',
      trackingId: MediaLibraryTrackingIds.MEDIA_TYPE_GIF_CHECKBOX,
    },
  ],
  paramKey: 'mediaItemTypes',
};

export interface MediaTypeFilterProps {
  isDisabled?: boolean;
  isInitiallyCollapsed?: boolean;
  section: FilterSection<string> | undefined;
  onChange: (
    sections: Map<MediaFilterParamKey, FilterSection<FilterValue>>,
  ) => void;
}

export const MediaTypeFilter = ({
  isDisabled,
  isInitiallyCollapsed,
  onChange,
  section = DEFAULT_MEDIA_TYPE_FILTER_SECTION,
}: MediaTypeFilterProps) => (
  <>
    <CollapsibleSection
      isCollapsed={isInitiallyCollapsed}
      title={FilterSectionTitle[section.paramKey]}
    >
      <CheckboxSetFilter
        isDisabled={isDisabled}
        onChange={onChange}
        section={section}
      />
    </CollapsibleSection>
    <HR />
  </>
);
